import { useState } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

type Category = '全て' | '技術進展' | 'XRニュース' | 'パートナー情報' | 'イベント情報';

interface NewsArticle {
  id: number;
  category: Exclude<Category, '全て'>;
  title: string;
  date: string;
  excerpt: string;
  image: string;
  content?: string;
}

export default function NewsPage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState<Category>('全て');

  const newsArticles: NewsArticle[] = [
    {
      id: 1,
      category: 'XRニュース',
      title: 'スマートグラスの最新トレンド2025',
      date: '2025年1月12日',
      excerpt: '次世代のスマートグラスがもたらす新しい体験と、Mawariネットワークとの連携について解説します。',
      image: 'https://public.readdy.ai/ai/img_res/652ca5190e4265c8373a5d11305f54c2.jpg',
    },
    {
      id: 2,
      category: 'パートナー情報',
      title: 'Mawariエコシステムの成長',
      date: '2025年1月8日',
      excerpt: 'Mawariネットワークの拡大と、新しいパートナーシップについての最新情報をお届けします。',
      image: 'https://readdy.ai/api/search-image?query=Growing%20network%20visualization%20with%20interconnected%20nodes%20expanding%20ecosystem%20concept%20soft%20gradient%20pink%20and%20purple%20colors%20modern%20abstract%20digital%20art%20clean%20background&width=600&height=400&seq=blog-002&orientation=landscape',
    },
    {
      id: 3,
      category: 'XRニュース',
      title: 'AIコンパニオンの未来',
      date: '2025年1月3日',
      excerpt: 'AIとARが融合した新しいコミュニケーション体験が、私たちの日常をどう変えるのか。',
      image: 'https://readdy.ai/api/search-image?query=Friendly%20AI%20hologram%20companion%20glowing%20softly%20interacting%20with%20person%20futuristic%20but%20warm%20atmosphere%20soft%20pink%20and%20purple%20light%20optimistic%20mood%20clean%20modern%20style&width=600&height=400&seq=blog-003&orientation=landscape',
    },
    {
      id: 4,
      category: '技術進展',
      title: 'DePINネットワークの革新',
      date: '2024年12月28日',
      excerpt: '分散型物理インフラネットワーク（DePIN）の最新技術動向と、Mawariが目指す未来について詳しく解説します。',
      image: 'https://readdy.ai/api/search-image?query=Decentralized%20network%20infrastructure%20visualization%20glowing%20nodes%20connected%20by%20light%20beams%20futuristic%20technology%20concept%20soft%20pink%20and%20purple%20gradient%20background%20clean%20modern%20digital%20art%20style&width=600&height=400&seq=news-tech-001&orientation=landscape',
    },
    {
      id: 5,
      category: 'イベント情報',
      title: 'MAWARI Freak定例会レポート',
      date: '2024年12月25日',
      excerpt: '12月のコミュニティ定例会で話し合われた内容と、参加者の皆様からの質問をまとめました。',
      image: 'https://readdy.ai/api/search-image?query=Online%20community%20meeting%20virtual%20gathering%20people%20connecting%20through%20screens%20warm%20friendly%20atmosphere%20soft%20lighting%20modern%20collaboration%20space%20pink%20and%20purple%20accents&width=600&height=400&seq=news-event-001&orientation=landscape',
    },
    {
      id: 6,
      category: 'パートナー情報',
      title: '新パートナー企業との提携発表',
      date: '2024年12月20日',
      excerpt: 'Mawariネットワークに新たなパートナー企業が加わりました。今後の展開にご期待ください。',
      image: 'https://readdy.ai/api/search-image?query=Business%20partnership%20handshake%20professional%20collaboration%20modern%20office%20setting%20soft%20natural%20lighting%20trust%20and%20growth%20concept%20clean%20minimalist%20style%20with%20pink%20and%20purple%20tones&width=600&height=400&seq=news-partner-001&orientation=landscape',
    },
    {
      id: 7,
      category: '技術進展',
      title: 'ブロックチェーン技術の最新動向',
      date: '2024年12月15日',
      excerpt: 'ブロックチェーン技術の進化と、Mawariプロジェクトへの応用について初心者にもわかりやすく説明します。',
      image: 'https://readdy.ai/api/search-image?query=Blockchain%20technology%20visualization%20digital%20blocks%20connected%20in%20chain%20glowing%20connections%20futuristic%20tech%20concept%20soft%20pink%20and%20purple%20gradient%20modern%20abstract%20style%20clean%20background&width=600&height=400&seq=news-tech-002&orientation=landscape',
    },
    {
      id: 8,
      category: 'XRニュース',
      title: 'メタバースとXRの融合',
      date: '2024年12月10日',
      excerpt: 'メタバース空間でのXR体験がどのように進化しているか、最新事例とともにご紹介します。',
      image: 'https://readdy.ai/api/search-image?query=Metaverse%20virtual%20reality%20space%20futuristic%20digital%20world%20with%20floating%20elements%20XR%20experience%20visualization%20soft%20pink%20and%20purple%20ambient%20lighting%20modern%20sci-fi%20aesthetic%20clean%20design&width=600&height=400&seq=news-xr-001&orientation=landscape',
    },
    {
      id: 9,
      category: 'イベント情報',
      title: '2025年ロードマップ発表',
      date: '2024年12月5日',
      excerpt: '2025年のMawariプロジェクトの展開予定と、コミュニティの皆様へのメッセージをお届けします。',
      image: 'https://readdy.ai/api/search-image?query=Future%20roadmap%20visualization%20timeline%20with%20milestones%20glowing%20path%20forward%20optimistic%20journey%20concept%20soft%20gradient%20pink%20and%20purple%20colors%20modern%20infographic%20style%20clean%20background&width=600&height=400&seq=news-event-002&orientation=landscape',
    },
  ];

  const categories: Category[] = ['全て', '技術進展', 'XRニュース', 'パートナー情報', 'イベント情報'];

  const filteredArticles = selectedCategory === '全て' 
    ? newsArticles 
    : newsArticles.filter(article => article.category === selectedCategory);

  return (
    <div className="min-h-screen bg-white">
      <Navbar isScrolled={isScrolled} />
      
      {/* ヒーローセクション */}
      <section className="pt-32 pb-16 px-6 bg-white">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            最新ニュース
          </h1>
          <p className="text-xl md:text-2xl text-gray-600 leading-relaxed">
            XR・クリプト・Mawariの最新情報をお届けします
          </p>
        </div>
      </section>

      {/* カテゴリフィルター */}
      <section className="py-8 px-6 bg-white sticky top-20 z-40 shadow-sm">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-wrap justify-center gap-3">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-6 py-3 rounded-full text-base font-semibold transition-all whitespace-nowrap cursor-pointer ${
                  selectedCategory === category
                    ? 'bg-gradient-to-r from-pink-500 to-purple-500 text-white shadow-lg scale-105'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* 記事一覧 */}
      <section className="py-16 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredArticles.map((article) => (
              <article
                key={article.id}
                className="group bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-105 cursor-pointer"
              >
                <div className="relative w-full h-56">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute top-4 left-4 px-4 py-2 bg-white/90 backdrop-blur-sm text-gray-900 text-sm font-semibold rounded-full">
                    {article.category}
                  </div>
                </div>
                <div className="p-8">
                  <p className="text-sm text-gray-500 mb-3">{article.date}</p>
                  <h3 className="text-xl font-bold text-gray-900 mb-4 leading-tight">
                    {article.title}
                  </h3>
                  <p className="text-base text-gray-600 leading-relaxed mb-6">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center text-pink-500 font-semibold">
                    記事を読む
                    <i className="ri-arrow-right-line ml-2 group-hover:translate-x-2 transition-transform"></i>
                  </div>
                </div>
              </article>
            ))}
          </div>

          {filteredArticles.length === 0 && (
            <div className="text-center py-20">
              <i className="ri-file-list-3-line text-6xl text-gray-300 mb-4"></i>
              <p className="text-xl text-gray-500">
                このカテゴリの記事はまだありません
              </p>
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
}